import React from 'react';
import {
  FooterContainer,
  Text,
  SocialMediaIcons,
  FooterBottom,
} from './styles';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import { COLORS } from '../../../values/colors';
import { Paragraph } from '../../../lib/Font/styles';
import { useNavigate } from 'react-router-dom';
import { CONSENT_OPEN_PREFERENCES_EVENT } from '../../../consent/config';

const Footer = () => {
  const navigate = useNavigate();

  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent(CONSENT_OPEN_PREFERENCES_EVENT));
  };

  return (
    <FooterContainer>
      <SocialMediaIcons>
        <FacebookOutlinedIcon style={{ color: COLORS.white, fontSize: '4rem' }} />
        <InstagramIcon style={{ color: COLORS.white, fontSize: '4rem' }} />
      </SocialMediaIcons>

      <FooterBottom>
        <Text onClick={() => navigate('/datenschutz')}>Datenschutz</Text>
        <Text onClick={() => navigate('/impressum')}>Impressum</Text>
        <Text onClick={() => navigate('/kontakt')}>Kontakt</Text>
        <Text onClick={openCookieSettings}>Cookie-Einstellungen</Text>
      </FooterBottom>
      <FooterBottom>
        <Paragraph>by <b>Max Bantle</b></Paragraph>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
